import React from "react";
import BaseHeader from "./BaseView/BaseHeader";
import BaseFooter from "./BaseView/BaseFooter";
import GridContainer from "../components/Grid/GridContainer";
import Parallax from "../components/Parallax/Parallax";
import {
	analysisMoving,
	analysisTiming,
	getLCStatus,
	getVideoInfo, videoAddCollect,
	videoAddLean, videoRemoveCollect, videoRemoveLean
} from "../utils/request";
import Button from "components/CustomButtons/Button.js";


import dynamicFile from 'dynamic-file'
import GridItem from "../components/Grid/GridItem";


import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import CollectionsIcon from '@material-ui/icons/Collections';

import ListAltIcon from '@material-ui/icons/ListAlt';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import CodeIcon from '@material-ui/icons/Code';
import GifIcon from '@material-ui/icons/Gif';
import PeopleIcon from '@material-ui/icons/People';
import ImportContactsIcon from '@material-ui/icons/ImportContacts';
import ForumIcon from '@material-ui/icons/Forum';

import presentationStyle from "assets/jss/material-kit-pro-react/views/presentationStyle.js";
import {withStyles} from "@material-ui/core";
import SeriesVideoTags from "./components/VideoTages";
import Rose from "../components/Typography/Rose";
import Warning from "../components/Typography/Warning";
import {withSnackbar} from "notistack";
import {connect} from "react-redux";
import classNames from "classnames";
import NavPills from "../components/NavPills/NavPills";
import Info from "../components/Typography/Info";

import Markdown from 'react-remarkable'
import marked from 'marked'
// import hljs from  'highlight.js/styles/atom-one-dark.css'

import Zmage from 'react-zmage'
import hljs from 'highlight.js'
import 'highlight.js/styles/atom-one-dark.css'
import {VideoTopic} from "./components/video_topic_list";
import Danger from "../components/Typography/Danger";
import Primary from "../components/Typography/Primary";
import LoadingCard from "./components/LoadingCard";
import intl from "react-intl-universal";



marked.setOptions({
	renderer: new marked.Renderer(),
	gfm: true,
	pedantic: false,
	sanitize: false,
	tables: true,
	breaks: true,
	smartLists: true,
	smartypants: true,
	highlight: function (code) {
		return hljs.highlightAuto(code).value;
	}

});

class Mockingbird extends React.Component {


	constructor(props, context) {
		super(props, context);
		const id = this.props.match.params.id;

		this.state = {
			videoId: id,
			title: '',

			tagList: [],
			topicList: [],

			//阿里云视频播放
			aaliVid: '',
			aaliPlayauth: '',
		};


		this.initSomeJS();
		this.checkPageVisibility();
	}

	initSomeJS = () => {
		if (!window.jquery) {
			dynamicFile([
				'https://g.alicdn.com/de/prismplayer/2.8.2/skins/default/aliplayer-min.css',
				'https://g.alicdn.com/de/prismplayer/2.8.2/aliplayer-min.js',
			]).then(() => {
				// alert('success！！！')
				// if (this.state.inPlan) {
					//保利威视
					// this.playVideo();

					//阿里云
					// this.playVideoAaLi();
				// }
			})
		}

	};


	viewGetVideoInfo = () => {
		getVideoInfo(this.state.videoId).then(res => {
			this.setState({
				gifUrl: res.data.gifUrl,
				gifUrlPreview: res.data.gifUrlPreview,
				width: res.data.width,
				height: res.data.height,
				title: res.data.title,
				videoDesc: res.data.videoDesc,
				solution: res.data.solution,
				videoCode: marked(res.data.videoCode),
				// videoCode: res.data.videoCode,
				seriesName: res.data.seriesName,
				seriesId: res.data.seriesId,
				tagList: res.data.tags,
				topicList: res.data.topic.topicList,
				topicName: res.data.topic.topicName,
				forum: res.data.forum,
				inPlan: (res.data.free || res.data.inPurview),

				//保利威视
				// vid: res.data.vid,
				// playsafe: res.data.playsafe,

				//阿里云
				aaliVid: res.data.aaliVid,
				aaliPlayauth: res.data.aaliPlayauth,
			}, () => {
				// alert(this.state.inPlan)

				document.title = this.state.title + " - RobinAlgo";
				if (this.state.inPlan) {
					//保利威视
					// this.playVideo();

					//阿里云
					this.playVideoAaLi();
					if (this.props.userLoginStatus) {
						getLCStatus(this.state.videoId, this.state.seriesId).then(res => {
							this.changeLearnStatusView(res.data.learn);
							this.changeCollectStatusView(res.data.collect);
						})
					}
				}
			})
		});
	};


	changeCollectStatusView = (status) => {
		if (status) {
			this.setState({
				userVideoCollectStatus: true,
			})
		} else {
			this.setState({
				userVideoCollectStatus: false,
			})
		}

	};

	changeLearnStatusView = (status) => {
		if (status) {
			this.setState({
				userVideoLeanStatus: true,
			})
		} else {
			this.setState({
				userVideoLeanStatus: false,
			})
		}

	};


	playVideoAaLi = () => {
		const jsCode = "var player = new Aliplayer({\n" +
			"                  id: \"J_prismPlayer\",\n" +
			"                  autoplay: false,\n" +
			"                  width:\"100%\",\n" +
			"                  height:\"80vh\",\n" +
			"                  vid:\"" + this.state.aaliVid + "\",\n" +
			"                  playauth:'" + this.state.aaliPlayauth + "',\n" +
			"                  cover:''\n" +
			"                });";
		// eslint-disable-next-line no-new-func
		new Function(jsCode)();
	};

	playVideo = () => {
		const jsCode = "var player = polyvObject('#videoPlayer')" +
			".videoPlayer({" +
			// "'width':'" + this.state.width + "'," +
			// "'height':'" + this.state.height + "'," +
			"'height':'80vh'," +
			"'width':'100%'," +
			"'vid' : '" + this.state.vid + "' ," +
			"'forceH5':true ," +
			"'playsafe': '" + this.state.playsafe + "'});";
		// eslint-disable-next-line no-new-func
		new Function(jsCode)();
	};


	componentDidMount() {
		this.viewGetVideoInfo();

		// 挂载滚动监听
		window.addEventListener('scroll', this.bindScroll)
	}

	componentWillUnmount() {
		// 移除滚动监听
		window.removeEventListener('scroll', this.bindScroll);
	}

	bindScroll = (event) => {
		// 滚动的高度
		const scrollTop = (event.srcElement ? event.srcElement.documentElement.scrollTop : false) || window.pageYOffset || (event.srcElement ? event.srcElement.body.scrollTop : 0);
		// 视窗高度
		const clientHeight = (event.srcElement && event.srcElement.documentElement.clientHeight) || document.body.clientHeight;
		// 页面高度
		const scrollHeight = (event.srcElement && event.srcElement.documentElement.scrollHeight) || document.body.scrollHeight;
		// 距离页面底部的高度
		const _pagePosition = scrollHeight - scrollTop - clientHeight;

		this.setState({
			pageLsatPosition: this.state.pagePosition,
			pagePosition: _pagePosition
		});

		// 判断距离页面底部的高度
		// console.log('pagePosition' + pagePosition)
	};

	checkPageVisibility = () => {
		setTimeout(() => {
			// console.log(document.visibilityState)
			analysisTiming().then(res => {

			});

			if (this.state.pagePosition !== this.state.pageLsatPosition) {
				this.setState({
					pageLsatPosition: this.state.pagePosition
				})
				analysisMoving().then(res => {

				});
			}
			this.checkPageVisibility()

		}, 60 * 1000);
		// }, 1000);
	};


	changeLeanStatus = () => {
		const status = !this.state.userVideoLeanStatus;
		if (status) {
			videoAddLean(this.state.videoId, this.state.seriesId).then(res => {
				if (res.code === 200) {
					this.props.enqueueSnackbar(intl.get('finish_study'), {variant: 'success'})
				}
			});

		} else {
			videoRemoveLean(this.state.videoId, this.state.seriesId).then(res => {
			})
		}
		this.changeLearnStatusView(status)
	};

	changeCollectStatus = () => {
		const status = !this.state.userVideoCollectStatus;
		if (status) {
			videoAddCollect(this.state.videoId, this.state.seriesId).then(res => {
				if (res.code === 200) {
					this.props.enqueueSnackbar(intl.get('add_to_collect'), {variant: 'success'})

				}
			})

		} else {
			videoRemoveCollect(this.state.videoId, this.state.seriesId).then(res => {
			})

		}
		this.changeCollectStatusView(status)
	};

	render() {
		const {classes} = this.props;

		const topics = this.state.topicList.map(data => {
			return <VideoTopic
				style={{
					cursor: 'pointer'
				}}
				data={data}
			/>
		});


		return (
			<div>
				<BaseHeader fixed/>
				<Parallax image={"https://robinalgo.oss-cn-shanghai.aliyuncs.com/plan_bg.jpg"}
						  filter="" small>
					{this.state.title === '' ?
						<div className={classes.container}>
							<GridContainer justify="center">
								<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
									<h2 className={classes.title} style={{color: "white"}}>
										{intl.get('robin_desc')}
									</h2>
								</GridItem>
							</GridContainer>
						</div>
						:
						<div className={classes.container}>
							<GridContainer justify="center">
								<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
									<h1 className={classes.title} style={{color: "white"}}>
										{this.state.title}
									</h1>
								</GridItem>
								<GridItem xs={12} sm={12} md={8} className={classes.textCenter}>
									<SeriesVideoTags data={this.state.tagList}/>
									<h4 className={classes.title} style={{color: "white"}}>
										{intl.get('show_more_series')} <Warning>
										<a href={'/series_info/' + this.state.seriesId}
										   style={{fontSize: '14pt'}}
										>{this.state.seriesName}</a>
									</Warning>
									</h4>
								</GridItem>
								{
									this.props.userLoginStatus ?
										<GridItem xs={12} sm={12} md={8}
												  className={classes.textCenter}>
											<Button
												onClick={this.changeLeanStatus}
												color={this.state.userVideoLeanStatus ? 'rose' : 'warning'}
											>
												<ThumbUpIcon/> &nbsp;&nbsp;&nbsp;&nbsp;{this.state.userVideoLeanStatus ? intl.get('learned') : intl.get('learn')}
											</Button>
											<Button
												onClick={this.changeCollectStatus}
												style={{marginLeft: '12px'}}
												color={this.state.userVideoCollectStatus ? 'rose' : 'warning'}
											>
												<CollectionsIcon/> &nbsp;&nbsp;&nbsp;&nbsp;{this.state.userVideoCollectStatus ? intl.get('collected') : intl.get('collect')}
											</Button>
										</GridItem>
										:
										null
								}
							</GridContainer>
						</div>
					}
				</Parallax>
				<div
					className={classNames(classes.main, classes.mainRaised)}
					id="main-panel"
					style={{paddingLeft: '3%', paddingRight: '3%'}}
				>

					{
						this.state.title === '' ?
							<GridContainer className={classes.section}>
								<LoadingCard type={5}/>
							</GridContainer>
							:

							<GridContainer className={classes.section}>

								{
									this.state.inPlan ?
										<GridItem xs={12} sm={12} md={12}>
											<div id={'J_prismPlayer'}
												 className={'prism-player'}/>
										</GridItem>
										:
										<GridItem>
											<Danger>
												<h2>
													{intl.get('permission_error')},
												</h2>
											</Danger>
											<Primary>
												<h2>
													<a href={"/plans"}>{intl.get('subscription')}</a>
												</h2>
											</Primary>

										</GridItem>
								}

								<GridItem xs={12} sm={12} md={12}>
									<NavPills
										active={0}
										color="primary"
										tabs={[
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('subject')}</span>,
												tabIcon: ImportContactsIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<Markdown
															source={this.state.videoDesc}/>
													</GridContainer>
												)
											},
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('solution')}</span>,
												tabIcon: InsertEmoticonIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<GridItem>
															<Warning>{intl.get('solution_tips')}</Warning>
														</GridItem>
														<GridItem>
															<Markdown
																source={this.state.solution}/>
														</GridItem>
													</GridContainer>
												)
											},
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('code')}</span>,
												tabIcon: CodeIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<div style={{
															// backgroundColor: "#000",
															width: '100%'
														}}>
															<div
																dangerouslySetInnerHTML={{__html: `${this.state.videoCode}`}}
																style={{}}/>
														</div>
													</GridContainer>
												)
											},
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('animation')}</span>,
												tabIcon: GifIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<GridItem>
															<Warning> {intl.get('animation_tips')}</Warning>
														</GridItem>
														<GridItem>
															{
																this.state.gifUrl === '' ?
																	<h4>{intl.get('no_gif')}</h4>
																	:
																	<Zmage
																		// backdrop={'rgba(0,0,0,0)'}
																		src={this.state.gifUrlPreview}
																		style={{
																			maxWidth: '400px',
																		}}
																		zIndex={19260817}
																		set={[
																			{
																				src: this.state.gifUrl,
																			},
																		]}/>
															}
														</GridItem>

													</GridContainer>
												)
											},
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('series')}</span>,
												tabIcon: ListAltIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<GridItem>
															<Warning>{intl.get('series_tips')}</Warning>
														</GridItem>
														<GridItem>
															{
																this.state.topicName === ''
																	?
																	<Rose>
																		<h3>
																			{intl.get('series_empty')}
																		</h3>
																	</Rose>
																	:
																	<div>
																		<h2>{this.state.topicName}</h2>
																		<div>
																			{topics}
																		</div>
																	</div>
															}
														</GridItem>
													</GridContainer>
												)
											},
											{
												tabButton: <span
													style={{fontSize: '10pt'}}>{intl.get('forum')}</span>,
												tabIcon: PeopleIcon,
												tabContent: (
													<GridContainer style={{
														backgroundColor: '#f0f0f0',
														padding: '12px'
													}}>
														<GridItem>
															<Warning>{intl.get('forum_tips')}</Warning>
														</GridItem>
														<GridItem>
															<a href={this.state.forum}
															   target="_blank">
																<ForumIcon/>&nbsp;&nbsp;{intl.get('menu_forum')}:&nbsp;&nbsp;{this.state.title}
															</a>
														</GridItem>
													</GridContainer>
												)
											},
										]}
									/>
								</GridItem>

							</GridContainer>

					}


				</div>
				<BaseFooter/>
			</div>
		)
	}
}

const mapStateToProps = state => ({
	userLoginStatus: state.userLoginStatus
});

export default connect(mapStateToProps)(withStyles(presentationStyle)(withSnackbar(Mockingbird)));
